import MenuItemsService from '../../services/MenuItemsService'
import ClientAppService from '../../services/ClientAppService'
import AxiosErrorHandler from '../../helpers/AxiosErrorHandler'
import MenuItemsHelper from '../../helpers/MenuItemsHelper'
import PoiService from '../../services/PoiService'

import router from '../../router'
export const namespaced = true

const initialState = {
  menuItems: [],
  selectedMenuItem: {},
  selectedMenuItemChildren: [],
  availablePoisForLinking: []
}

export const state = {
  menuItems: [],
  menuItemTypes: [],
  selectedMenuItem: {},
  selectedMenuItemChildren: [],
  availablePoisForLinking: []
}

export const mutations = {
  SET_MENU_ITEMS(state, recs) {
    state.menuItems = MenuItemsHelper.parseMenuItems(recs)
  },
  SET_MENU_ITEM_TYPES(state, recs) {
    state.menuItemTypes = recs
  },
  SET_SELECTED_MENU_ITEM(state, rec) {
    state.selectedMenuItem = rec
  },
  SET_SELECTED_MENU_ITEM_CHILDREN(state, recs) {
    state.selectedMenuItemChildren = recs
  },
  RESET_STORE(state) {
    Object.assign(state, initialState)
  }
}

export const actions = {
  fetchMenuItems: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return ClientAppService.getMenuItems(
      context.rootGetters['ClientAppStore/getSelectedClientAppId']
    ).then(
      r => {
        context.commit('SET_MENU_ITEMS', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_MENU_ITEMS', [])
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  fetchMenuItemTypes: function(context) {
    return MenuItemsService.getMenuItemTypes().then(
      r => {
        context.commit('SET_MENU_ITEM_TYPES', r.data)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
      },
      e => {
        context.commit('SET_MENU_ITEM_TYPES', null)
        context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        AxiosErrorHandler.handler(e, context, router)
      }
    )
  },
  selectMenuItem: function(context, value) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    return MenuItemsService.getMenuItemById(value)
      .then(
        r => {
          context.commit('SET_SELECTED_MENU_ITEM', r.data)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
        },
        e => {
          context.commit('SET_SELECTED_MENU_ITEM', null)
          context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          AxiosErrorHandler.handler(e, context, router)
        }
      )
      .then(
        MenuItemsService.getMenuItemChildren(value).then(
          r => {
            context.commit('SET_SELECTED_MENU_ITEM_CHILDREN', r.data)
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
          },
          e => {
            context.commit('SET_SELECTED_MENU_ITEM_CHILDREN', null)
            context.commit('SET_LOADING_STATUS', 'idle', { root: true })
            AxiosErrorHandler.handler(e, context, router)
          }
        )
      )
  },
  createMenuItem: function(context, value) {
    return MenuItemsService.createMenuItem(value)
      .then(res => {
        context.dispatch('fetchMenuItems')
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  updateMenuItem: function(context, value) {
    MenuItemsService.updateMenuItemData(value)
      .then(res => {
        context.dispatch('fetchMenuItems')
      })
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  deleteMenuItem: async function(context, value) {
    let res
    try {
      if (value.children && value.children.lenght != 0) {
        for (let child of value.children) {
          await context.dispatch('deleteMenuItem', child)
        }
      }
      return MenuItemsService.deleteMenuItem(value.id)
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
  },
  linkMenuItemWithPois: function(context, value) {
    MenuItemsService.linkMenuItemWithPois(value)
      .then(res => {})
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  linkMenuItemWithMedia: function(context, value) {
    MenuItemsService.linkMenuItemWithMedia(value)
      .then(res => {})
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  removePoiFromMenuItem: function(context, value) {
    MenuItemsService.removePoiForMenuItem(value)
      .then(res => {})
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  removeMediaFromMenuItem: function(context, value) {
    MenuItemsService.removeMediaForMenuItem(value)
      .then(res => {})
      .catch(e => {
        AxiosErrorHandler.handler(e, context, router)
      })
  },
  updateMenuItemsChildren: async function(context, value) {
    try {
      for (let item of value) {
        if (item.children && item.children.lenght != 0) {
          context.dispatch('updateMenuItemsChildren', item.children)
          MenuItemsService.updateMenuItemChildren(item.children, item.id)
        }
      }

      context.dispatch('fetchMenuItems')
    } catch (e) {
      AxiosErrorHandler.handler(e, context, router)
    }
  },
  resetStore: async function(context) {
    context.commit('SET_LOADING_STATUS', 'loading', { root: true })
    context.commit('RESET_STORE')
    context.commit('SET_LOADING_STATUS', 'idle', { root: true })
  }
}

export const getters = {
  getSelectedMenuItemId: state => {
    return state.selectedMenuItem ? state.selectedMenuItem.id : 0
  }
}
